function updateSellingPlan(line, quantity, selling_plan) {
  let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  cart.setActiveElement(document.activeElement);

  toggleCartLoading(line, true);

  fetch(`${routes.cart_change_url}?section_id=cart-drawer`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      line,
      quantity,
      selling_plan,
      sections: cart.getSectionsToRender().map((section) => section.id)
    })
  })
  .then((response) => {
    return response.text();
  })
  .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(() => {
    toggleCartLoading(line, false);
  });
}

function toggleCartLoading(line, isLoading = true) {
  const cartContainer = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
  cartContainer?.classList.toggle('cart__items--disabled', isLoading);

  const selectors = `#CartItem-${line} .loading-overlay, #CartDrawer-Item-${line} .loading-overlay`;
  const overlays = document.querySelectorAll(selectors);

  overlays.forEach((overlay) => overlay.classList.toggle('hidden', !isLoading));
  if (isLoading) document.activeElement?.blur();
}

class MMSellingPlanButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();

      const quantity = this.closest('.cart-item').querySelector('.quantity__input').value;
      const index = this.dataset.index;
      const sellingId = this.dataset.sellingId;

      updateSellingPlan(index, quantity, sellingId);
    });
  }
}

customElements.define('mm-selling-plan-button', MMSellingPlanButton);

class MMSellingPlanDropdown extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.spd-trigger');
    this.optionsContainer = this.querySelector('.spd-options');
    this.select = this.querySelector('select[name="selling_plan"]');

    this.trigger?.addEventListener('click', this.toggleDropdown.bind(this));
    this.optionsContainer?.addEventListener('click', this.handleOptionClick.bind(this));
    document.addEventListener('click', this.closeDropdown.bind(this));
  }

  toggleDropdown(event) {
    event.stopPropagation();
    this.optionsContainer?.classList.toggle('active');
  }

  handleOptionClick(event) {
    const index = this.dataset.index;
    const option = event.target.closest('.spd-option');
    if (!option || !index) return;

    const value = option.dataset.value;

    this.querySelectorAll('.spd-option').forEach(o => o.removeAttribute('data-selected'));
    option.setAttribute('data-selected', true);

    this.trigger.querySelector('.spd-text').textContent = option.querySelector('span').textContent;
    if (this.select) this.select.value = value;
    this.optionsContainer?.classList.remove('active');

    const quantity = this.closest('.cart-item').querySelector('.quantity__input').value || 1;
    updateSellingPlan(index, quantity, value);
  }

  closeDropdown(event) {
    if (this.contains(event.target)) return;
    this.optionsContainer?.classList.remove('active');
  }
}

customElements.define('mm-selling-plan-dropdown', MMSellingPlanDropdown);